module.exports = __webpack_public_path__ + "img/info_txt_cover.f09db52.png";